import './counter-signature-module-screen.scss'

import { defineComponent, PropType } from 'vue';
import _ from 'lodash';
import { faArrowLeft, faCheck, faPlusCircle } from "@fortawesome/free-solid-svg-icons";

import { CounterSignatureResource, CounterSignerResource, createTranslatedString, editTranslatedString, getTranslatedString } from "@skinsoft/types";

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { CLOSE_COUNTER_SIGNATURE_MODULE_TOPIC, COUNTER_SIGNATURE_UPDATED, COUNTER_SIGNER_UPDATED, REMOVE_COUNTER_SIGNATURE, REMOVE_COUNTER_SIGNER, SAVE_CONTRE_SIGNED_REPORT, SIGNATURE_UPDATED } from "../../../../busTopics";
import { CounterSignature } from "../../../report-edition/summary-area/counter-signatures/counter-signature";
import { CounterSigner } from '../../../report-edition/summary-area/counter-signatures/counter-signature/counter-signer';
import { SigningArea } from '../signing-area';

export const CounterSignatureModuleScreen = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sCounterSignature: CounterSignature,
        sCounterSigner: CounterSigner,
        sSigningArea: SigningArea,
    },
    props: {
        counterSignature: {
            type: Object as PropType<CounterSignatureResource>,
            required: true,
        }
    },
    template: require('./counter-signature-module-screen.html'),
    data() {
        return {
            updatedCounterSignature: {} as CounterSignatureResource,
            lastSignerId: 0,
            showSaveWarning: false,
            showExitWarning: false,

            plusIcon: faPlusCircle,
            saveIcon: faCheck,
            backIcon: faArrowLeft,

            SIGNATURE_UPDATED,
            COUNTER_SIGNATURE_UPDATED,
            REMOVE_COUNTER_SIGNER,
            COUNTER_SIGNER_UPDATED,
        }
    },
    mounted() {
        this.cloneCounterSignature()
    },
    computed: {
        reason(): string {
            return getTranslatedString(this.updatedCounterSignature.reason, this.getAppLocale())
        },
        comment(): string {
            return getTranslatedString(this.updatedCounterSignature.comment, this.getAppLocale())
        },
        location(): string {
            return getTranslatedString(this.updatedCounterSignature.location, this.getAppLocale())
        },
    },
    methods: {
        getSignature(arrayIndex: number): string {
            if(this.updatedCounterSignature.observationCarriedPresenceOfs?.length) {
                const signer = this.updatedCounterSignature.observationCarriedPresenceOfs[arrayIndex]
                if(signer && signer.signature) {
                    return signer.signature
                }
            }
            return ''
        },
        onCounterSignatureUpdated(updatedSignature: CounterSignatureResource) {
            this.updatedCounterSignature = updatedSignature
        },
        onSignatureUpdated(signature: string, index: number) {
            if(this.updatedCounterSignature.observationCarriedPresenceOfs?.length) {
                const signerIndexInArray = this.updatedCounterSignature.observationCarriedPresenceOfs?.findIndex(signer => {
                    return signer.index === index
                })
                if(signerIndexInArray !== undefined && signerIndexInArray > -1) {
                    let updatedSigner = this.updatedCounterSignature.observationCarriedPresenceOfs[signerIndexInArray]
                    if(updatedSigner.signature) {
                        updatedSigner.signature = signature
                    } else {
                        _.set(updatedSigner, 'signature', signature)
                    }
                    this.updatedCounterSignature.observationCarriedPresenceOfs?.splice(signerIndexInArray, 1, updatedSigner)
                }
            }
        },
        onAddSigner() {
            this.lastSignerId++
            const blankSigner: CounterSignerResource = {
                index: this.lastSignerId,
                surnameFirstName: createTranslatedString(this.getAppLocale(), ""),
                function: undefined,
                signature: undefined,
            }

            if(this.updatedCounterSignature.observationCarriedPresenceOfs) {
                this.updatedCounterSignature.observationCarriedPresenceOfs.push(blankSigner)
            } else {
                _.set(this.updatedCounterSignature, 'observationCarriedPresenceOfs', [blankSigner])
            }
        },
        onDeleteCounterSigner(index: number) {
            const signerIndexInArray = this.updatedCounterSignature.observationCarriedPresenceOfs?.findIndex(signer => {
                return signer.index === index
            })
            if(signerIndexInArray !== undefined && signerIndexInArray > -1) {
                this.updatedCounterSignature.observationCarriedPresenceOfs?.splice(signerIndexInArray, 1)
            }
        },
        onCounterSignerUpdated(updatedSigner: CounterSignerResource, index: number) {
            const signerIndexInArray = this.updatedCounterSignature.observationCarriedPresenceOfs?.findIndex(signer => {
                return signer.index === index
            })
            if(signerIndexInArray !== undefined && signerIndexInArray > -1) {
                this.updatedCounterSignature.observationCarriedPresenceOfs?.splice(signerIndexInArray, 1, updatedSigner)
            }
        },
        warnBeforeSave() {
            this.showSaveWarning = true
            this.showExitWarning = false
            this.goToTopOfPage()
        },
        warnBeforeCloseSignatureModule() {
            this.showExitWarning = true
            this.showSaveWarning = false
            this.goToTopOfPage()
        },
        dismissWarning() {
            this.showSaveWarning = false
            this.showExitWarning = false
        },
        save() {
            this.$emit(SAVE_CONTRE_SIGNED_REPORT, [this.updatedCounterSignature, this.counterSignature.index])
            this.emitOnBus(CLOSE_COUNTER_SIGNATURE_MODULE_TOPIC)
        },
        closeSignatureModule() {
            this.$emit(REMOVE_COUNTER_SIGNATURE, this.counterSignature.index)
            this.emitOnBus(CLOSE_COUNTER_SIGNATURE_MODULE_TOPIC)
        },
        cloneCounterSignature() {
            this.updatedCounterSignature = _.cloneDeep(this.counterSignature)
            if(this.updatedCounterSignature.observationCarriedPresenceOfs?.length) {
                const lastSignerIndex = this.updatedCounterSignature.observationCarriedPresenceOfs.length - 1
                this.lastSignerId = this.updatedCounterSignature.observationCarriedPresenceOfs[lastSignerIndex].index ?? 0
            }
        },
        goToTopOfPage() {
            // @ts-ignore
            if((this.$refs.anchor as Element).scrollIntoView ) {
                (this.$refs.anchor as Element).scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                })
            }
        },
    },
    watch: {
        counterSignature() {
            this.cloneCounterSignature()
        },
    },
})
